var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.l),function(i){return _c('span',{key:i.flag},[(i.val)?[_vm._v(_vm._s(i.val))]:_vm._e(),(i.flag)?_c('v-chip',{attrs:{"outline":"","color":i.color || 'primary'}},[_vm._v(_vm._s(i.flag))]):_vm._e()],2)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }